import React from "react";
import { PatientSummary } from "../../../types";
import PatientsTable from "./patients-table";

interface PatientsTableViewProps {
  filteredPatients: PatientSummary[];
  unfilteredPatientsCount: number;
}

const PatientsTableView: React.FC<PatientsTableViewProps> = ({
  filteredPatients,
  unfilteredPatientsCount,
}) => {
  return <PatientsTable filteredPatients={filteredPatients} unfilteredPatientsCount={unfilteredPatientsCount} />;
};

export default PatientsTableView;
